<template>
    <div
        v-html="html_card"
        :style="`
            width: ${settings.layout.width ? settings.layout.width : '100%'};
            margin-top: ${settings.layout.margin.top ? settings.layout.margin.top : '0px'};
            margin-right: ${settings.layout.margin.right ? settings.layout.margin.right : '0px'};
            margin-bottom: ${settings.layout.margin.bottom ? settings.layout.margin.bottom : '15px'};
            margin-left: ${settings.layout.margin.left ? settings.layout.margin.left : '0px'};
        `"
    ></div>
</template>

<script>
export default {
    name: 'HtmlCardConfig',
    props: {
        html_card:{type:String},
        settings:{default:null}
    }
}
</script>
